import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';


@Injectable()
export class ResponsiveRouteGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate() {
    if(window.innerWidth > 992){
      return true;
    }else{
      this.router.navigate(['mobile']);
    }
  }
}